import { render, staticRenderFns } from "./PurchasesOutdated.vue?vue&type=template&id=48ce2555"
import script from "./PurchasesOutdated.vue?vue&type=script&lang=js"
export * from "./PurchasesOutdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports